import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core';
import MUISwitch from '@material-ui/core/Switch';
import MUIFormControlLabel from '@material-ui/core/FormControlLabel';
import MUIFormHelperText from '@material-ui/core/FormHelperText';
import MUIFormControl from '@material-ui/core/FormControl';
import FormContext from '../FormContext';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'space-between'
  }
});
const Switch = ({
  label,
  dataField,
  helperText,
  disabled = false,
  injectAction
}) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const id = `form-field/${dataField}`;
  const { getFieldValue, setFieldValue } = useContext(FormContext);
  const checked = getFieldValue(dataField);

  function getLabel() {
    return label ? formatMessage({ id: label }) : label;
  }

  function getHelperText() {
    return helperText ? formatMessage({ id: helperText }) : helperText;
  }

  return (
    <MUIFormControl variant="filled" margin="normal" fullWidth>
      <MUIFormControlLabel
        labelPlacement="start"
        classes={classes}
        control={
          <MUISwitch
            id={id}
            checked={checked}
            onChange={event => {
              if (injectAction) {
                injectAction(event.target.checked);
              }
              setFieldValue(dataField, event.target.checked);
            }}
            disabled={disabled}
          />
        }
        label={getLabel()}
      />
      <MUIFormHelperText>{getHelperText()}</MUIFormHelperText>
    </MUIFormControl>
  );
};

Switch.propTypes = {
  label: PropTypes.string.isRequired,
  dataField: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  disabled: PropTypes.bool
};

export default Switch;
